export default {
  'authenticatedPage.redirectMessageHeader': 'You are being redirected to:',
  'authenticatedPage.noPermissions':
    'You do not currently have permissions to view any application.',
  'authenticatedPage.noAccessMessage':
    'You do not have access to any application. Please contact your administrator.',
};
